import { Button } from 'react-bootstrap';
import BinIcon, { TIconsNames } from '../../components/icon/IconWrapped';
import { NoConnectionBackground } from './styled/NoConnectionStyled';
import { getIsLocationPlatformMobileSelector } from '../../modules/Location/locationSelectors';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { CSSProperties } from 'react';

interface INoConnectionProps {
    background?: CSSProperties['background'],
    buttonVariant?: 'primary' | 'secondary',
    btnText?: string,
    className?: string,
    description?: string,
    iconName?: TIconsNames,
    iconSize?: number,
    onClick?: () => void,
    title?: string,
}

export const NoConnection = (props: INoConnectionProps) => {
    const {
        background,
        buttonVariant = 'primary',
        className,
        iconName = 'IcDisconnect',
        iconSize = 48,
        title = 'Houston, no connection',
        description = 'No worries! Please check the Internet or try again',
        btnText = 'Retry',
        onClick = () => {
            window.location.reload();
        },
    } = props;
    const isPlatformMobile = useSelector(getIsLocationPlatformMobileSelector);

    return <NoConnectionBackground background={background} className={className}>
        <div className={'bg-icon'}>
            <BinIcon
                name={iconName}
                size={iconSize}
                className={'flex-shrink-0'}
            />
        </div>
        <h2 className={'title'}>{title}</h2>
        <span className={'description'}>{description}</span>
        <Button
            variant={buttonVariant}
            onClick={onClick}
            className={classNames('retry-button', { 'mobile': isPlatformMobile })}
        >{btnText}</Button>
    </NoConnectionBackground>;
};
